import EmailAttachment from "@/domain/entities/emails/EmailAttachement";
import { X } from "lucide-react";
import { Button } from "../../ui/button";
import getAttachmentIcon from "./attachmentIcon";

interface AttachmentChipProps {
    attachment: EmailAttachment;
    onClick?: () => void;
    // When omitted, the remove cross is hidden (read-only variant, e.g. in a thread).
    onRemove?: () => void;
}

const AttachmentChip = ({
    attachment,
    onClick,
    onRemove,
}: AttachmentChipProps) => (
    <div className="flex cursor-pointer items-center rounded-lg border hover:bg-surface-secondaryHover">
        <Button
            className="rounded-lg hover:bg-transparent"
            onClick={onClick}
            size="sm"
            variant="ghost"
        >
            {getAttachmentIcon(attachment)}
            <span className="max-w-[100px] truncate">{attachment.name}</span>
        </Button>
        {onRemove && (
            <Button
                className="mr-1"
                onClick={(e) => {
                    e.stopPropagation();
                    onRemove();
                }}
                size="tinyCircle"
                variant="ghost"
            >
                <X className="h-4 w-4" />
            </Button>
        )}
    </div>
);

export default AttachmentChip;
